import React from "react";
import { useRoutes } from "react-router-dom";
import AboutUspage from "../Pages/AboutUsPage/aboutUs";
import ContactUsPage from "../Pages/ContactUsPage/contactUsPage";
import BlogsPage from "../Pages/BlogsPage/blogsPage";
import ProductPage from "../Pages/ProductPage/productPage";
import HomePage from "../Pages/HomePage/homePage";
import { HomeInterior } from "../Pages/ProductPage/productspages/HomeInterior/homeInterior";
import { TermConditionspage } from "../Pages/TermsCondition/terms&ConditionsPage";
import { PravicyPolicy } from "../Pages/TermsCondition/pravicyPolicy";
import useScrollToTop from "../CommonComponents/useScrolletoTop";
import { BlogDetailsPage } from "../Pages/BlogsPage/BlogDetailsPage";
import UpvcVariantPage from "../Pages/ProductPage/productspages/UPVCpages/upvcVariantPage";
import { ProductDetailsPage } from "../Pages/ProductPage/productspages/SingleProducts/productDetailspage";
import AccessoriesShopPage from "../Pages/ProductPage/productspages/SingleProducts/accessoriesShopPage";
import RecentProject from "../Pages/ProductPage/productspages/SingleProducts/recentProject";
import AccessoriesPage from "../Pages/ProductPage/productspages/SingleProducts/accessoriesPage";
import RecentProjectPage from "../Pages/RecentProjectPage/recentProjectPage";
import PageTitle from "../CommonComponents/pageTitle";
import { useSelector } from "react-redux";
import { BecomeAdealerPage } from "../Pages/BecomeADealerPage/becomeAdealerPage";
import { NotFoundPage } from "../Pages/notFoundPage";
import CertificationPage from "../Pages/CertificationPage/CertificationPage";

function ProjectRoutes() {
  const progress = useSelector((state) => state.slugData.progress);
  //   // console.log(progress, 'progress');

  useScrollToTop();

  const elements = useRoutes([
    {
      path: "/",
      element: (
        <>
          <PageTitle title={""}></PageTitle>
          <HomePage title="" description="" keyword="" />
        </>
      ),
    },
    {
      path: "/about-us/",
      element: (
        <>
          <PageTitle title={"About us"}></PageTitle>
          <AboutUspage title="About us" description="." keyword="" />
        </>
      ),
    },
    {
      path: "/locate-us/",
      element: (
        <>
          <PageTitle
            title={"Tube Flex India | locate us | Entrance Matting System"}
          ></PageTitle>
          <ContactUsPage
            title="Tube Flex India | locate us"
            description=""
            keyword="Tube Flex India, contact us,"
          />
        </>
      ),
    },
    {
      path: "/blogs/",
      element: (
        <>
          <PageTitle
            title={
              "Blog"
            }
          ></PageTitle>
          <BlogsPage title="Blog " description="" keyword="" />
        </>
      ),
    },
    {
      path: "/products/:slug",
      element: (
        <>
          {progress && <PageTitle title={progress}></PageTitle>}
          <ProductDetailsPage />
        </>
      ),
    },
    {
      path: "/:slug",
      element: (
        <>
          {progress && <PageTitle title={progress}></PageTitle>}
          <HomeInterior />
        </>
      ),
    },
    { path: "/terms-&-Condition/", element: <TermConditionspage /> },
    { path: "/privacy-policy/", element: <PravicyPolicy /> },
    { path: "/blog-details-page/:slug", element: <BlogDetailsPage /> },
    {
      path: "/:slug/:slug",
      element: (
        <>
          {progress && <PageTitle title={progress}></PageTitle>}
          <UpvcVariantPage />{" "}
        </>
      ),
    },
    {
      path: "/become-a-dealer/",
      element: (
        <>
          <PageTitle
            title={"Become a Dealer | Upvc window in delhi NCR"}
          ></PageTitle>
          <BecomeAdealerPage />
        </>
      ),
    },
    { path: "/accessories-shop/:slug", element: <AccessoriesShopPage /> },
    { path: "/accessories/:slug", element: <AccessoriesPage /> },
    { path: "/recent-project/:slug", element: <RecentProject /> },
    { path: "/all-recent-project/", element: <RecentProjectPage /> },
    { path: "/not-found", element: <NotFoundPage /> },
    { path: "/certification", element: <CertificationPage /> },
    { path: "*", element: <NotFoundPage /> },
  ]);

  return elements;
}
export default ProjectRoutes;
